import { EmailDelivery, Registration, Webinar } from "../../webinars/types";
import { isPastWebinar } from "../../webinars/availability";
import { deliveryTone } from "../../webinars/emailStatus";

interface AdminOverviewProps {
  webinars: Webinar[];
  /** The current round's registrations: archived ones aren't counted */
  registrations: Registration[];
  deliveries: EmailDelivery[];
}

/** Upcoming = visible to the public, not cancelled, and not finished yet */
const isUpcoming = (w: Webinar) => (w.status === "published" || w.status === "registration_closed") && !isPastWebinar(w);

export default function AdminOverview({ webinars, registrations, deliveries }: AdminOverviewProps) {
  const upcomingIds = new Set(webinars.filter(isUpcoming).map(w => w.id));
  const active = new Set(registrations.filter(r => r.status !== "cancelled").map(r => r.id));
  const failedEmails = deliveries.filter(d => deliveryTone(d) === "failed" && active.has(d.registrationId)).length;
  const stats = [
    { label: "Current registrations", value: registrations.length, tone: "ink" },
    {
      label: "Registrations for upcoming webinars",
      value: registrations.filter(r => r.status !== "cancelled" && upcomingIds.has(r.webinarId)).length,
      tone: "navy",
    },
    { label: "Upcoming events", value: upcomingIds.size, tone: "navy" },
    { label: "Cancelled registrations", value: registrations.filter(r => r.status === "cancelled").length, tone: "red" },
    { label: "Emails that failed", value: failedEmails, tone: failedEmails ? "red" : "ink" },
  ];

  return (
    <section className="wa-stats" aria-label="Overview">
      {stats.map(stat => (
        <div key={stat.label} className="wa-stat">
          <span>{stat.label}</span>
          <strong className={`wa-stat-value wa-stat-value--${stat.tone}`}>{stat.value}</strong>
        </div>
      ))}
    </section>
  );
}
